import script from "./ticketing.vue?vue&type=script&setup=true&lang=js"
export * from "./ticketing.vue?vue&type=script&setup=true&lang=js"

import "./ticketing.vue?vue&type=style&index=0&id=c19e27b2&lang=scss"

const __exports__ = script;

export default __exports__